const WIDGET_MAPPING = {
  navigation: "logo",
  heroImage: "hero_image",
  bannerImage: "banner_image",
  featuredPicks: "featured_picks",
  bannerWithMessage: "banner_with_message",
  shopByCategory: "shop_by_category",
  featuredBrandWithItems: "featured_brand_with_items",
  featuredProduct: "featured_product",
  featuredShops: "featured_shops",
  imageWithTextOnRight: "image_with_text_on_right",
  imageWithTextOnLeft: "image_with_text_on_left",
  shopOurCatalog: "shop_our_catalog",
  myDesignedSwag: "shop_designed_swags",
  textOnly: "text_only",
  catalogHeroImageWithButton: "catalog_hero_image_with_button",
  catalogMarketingBanner: "catalog_marketing_banner",
  offeringsSection: "catalog_offerings",
  giftCatalog: "gift_catalog",
  lockerCatalog: "locker_catalog",
  countryCarousel: "country_carousel",
  productCarousel: "kit_carousel",
  onBoardingPackagesDetails: "onboarding_package_details",
  bookACallSection: "book_a_call_section",
  shopWorldwide: "shop_worldwide",
  countryFeaturedPicks: "country_featured_picks",
  countryFeaturedBrands: "country_featured_brands",
  countryFeaturedCategories: "country_featured_categories",
  custom: "custom",
  bestBrands: "best_brands",
  bestSellingProducts: "best_selling_products",
  faqs: "faqs",
  collapsibleBanner: "collapsible_message",
  recognition: "recognition",
  trendingShopTemplates: "trending_shop_templates",
  caseStudies: "case_studies",
  productListing: "product_listing_page",
  searchProductListing: "search_page",
  brandProductListing: "brand_page",
  collectionProductListing: "collection_page",
  plasmicContent: "plasmic_content",
  cartPage: "cart_page",
  checkoutPage: "checkout_page",
  orderConfirmationPage: "order_confirmation_page",
  productDetailPage: "product_detail_page",
  youMightAlsoLike: "similar_products",
  moreFromThisBrand: "more_from_brand",
  redeemGiftCardPage: "redeem_gift_card_page",
  themedCollection: "theme_collection",
};

export const {
  navigation,
  heroImage,
  bannerImage,
  featuredPicks,
  featuredShops,
  bannerWithMessage,
  shopByCategory,
  featuredBrandWithItems,
  featuredProduct,
  imageWithTextOnRight,
  imageWithTextOnLeft,
  shopOurCatalog,
  myDesignedSwag,
  textOnly,
  catalogHeroImageWithButton,
  catalogMarketingBanner,
  offeringsSection,
  giftCatalog,
  lockerCatalog,
  countryCarousel,
  productCarousel,
  onBoardingPackagesDetails,
  bookACallSection,
  shopWorldwide,
  countryFeaturedPicks,
  countryFeaturedBrands,
  countryFeaturedCategories,
  custom,
  bestBrands,
  bestSellingProducts,
  faqs,
  collapsibleBanner,
  recognition,
  trendingShopTemplates,
  caseStudies,
  productListing,
  searchProductListing,
  brandProductListing,
  collectionProductListing,
  plasmicContent,
  cartPage,
  checkoutPage,
  orderConfirmationPage,
  productDetailPage,
  youMightAlsoLike,
  moreFromThisBrand,
  redeemGiftCardPage,
  themedCollection,
} = WIDGET_MAPPING;
